import { useState } from "react";
import { CoinsTransferArea } from "./components/coin-transfer-area";
import { ConvertPoints } from "./components/convert-points";
import { SalesHistory } from "./components/sales-history";
import { t } from "../../i18n";

type Tab = "sale" | "convert" | "history";

export const InfoTransfer = () => {
  const token = localStorage.getItem("@token");
  const [tab, setTab] = useState<Tab>("sale");

  if (!token) {
    return null;
  }

  // Identical box on every tab: fixed height, one line, same weight — only the
  // colour and the underline change, so the menu never jumps or wraps.
  const tabStyle = (active: boolean) => ({
    // grows with its label (weight is the same on every tab, so the widths never
    // change when the selection changes) — "Converter pontos" fits at 360 px
    flex: "1 1 auto",
    minWidth: 0,
    height: "48px",
    padding: "0 6px",
    background: "transparent",
    border: "none",
    borderBottom: `3px solid ${active ? "#3f51b5" : "transparent"}`,
    color: active ? "#3f51b5" : "#777",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "45px",
    whiteSpace: "nowrap" as const,
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer",
  });

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        background: "#f0f3fc",
        minHeight: "100vh",
      }}
    >
      {/* top menu: Transfer (sale) | Convert points | History */}
      <div
        style={{
          display: "flex",
          background: "#fff",
          borderBottom: "1px solid #e6e6ef",
          position: "sticky",
          top: 0,
          zIndex: 1,
          height: "48px",
        }}
      >
        <button style={tabStyle(tab === "sale")} onClick={() => setTab("sale")}>
          {t("tabs.transfer")}
        </button>
        <button
          style={tabStyle(tab === "convert")}
          onClick={() => setTab("convert")}
        >
          {t("tabs.convert")}
        </button>
        <button
          style={tabStyle(tab === "history")}
          onClick={() => setTab("history")}
        >
          {t("tabs.history")}
        </button>
      </div>

      {tab === "sale" ? (
        <CoinsTransferArea />
      ) : tab === "convert" ? (
        <ConvertPoints />
      ) : (
        <div style={{ padding: "12px" }}>
          <SalesHistory />
        </div>
      )}
    </div>
  );
};
